// extracted by mini-css-extract-plugin
module.exports = {"skeletonDisplayerImg":"DisplayerLoadingSkeleton_skeletonDisplayerImg__2IipI","skeletonDisplyerInformation":"DisplayerLoadingSkeleton_skeletonDisplyerInformation__ZyW9j"};